import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	release: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'project-directories.versions.release-version-modal.header',
		defaultMessage: 'Release {name}',
		description: '',
	},
	release: {
		id: 'project-directories.versions.release-version-modal.release',
		defaultMessage: 'Release',
		description: '',
	},
	cancel: {
		id: 'project-directories.versions.release-version-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
});
export default messages;
